import type { AnnotationSource } from './imageAnnotations';
import { readVideoComments, type VideoComment } from './videoComments';
import type { ReviewContext } from './reviewContext';
export interface VideoReference { url: string; name: string; time: number; frame?: number }
export interface MediaSource extends AnnotationSource { kind?: 'image' | 'video'; time?: number; comments?: VideoComment[]; attachmentId?: number; reviewContext?: ReviewContext; downloadUrl?: string; playbackPrepared?: boolean }
export type ReviewAttachment = (file: File, reference?: VideoReference) => Promise<void>;
export function timecode(seconds: number) {
  const ms = Math.max(0, Math.round(seconds * 1000));
  return `${String(Math.floor(ms / 3600000)).padStart(2, '0')}:${String(Math.floor(ms / 60000) % 60).padStart(2, '0')}:${String(Math.floor(ms / 1000) % 60).padStart(2, '0')}.${String(ms % 1000).padStart(3, '0')}`;
}
export function videoReferenceHtml(reference: VideoReference) {
  const url = new URL(reference.url, window.location.href);
  if (!['http:', 'https:', 'blob:'].includes(url.protocol)) return '';
  const p = document.createElement('p'), a = document.createElement('a');
  url.hash = `t=${reference.time.toFixed(3)}`; a.href = url.href;
  a.dataset.videoReview = 'true'; a.dataset.videoTime = String(reference.time); a.dataset.videoName = reference.name;
  a.textContent = `▶ ${reference.name} · ${timecode(reference.time)}${reference.frame ? ` · кадр ${reference.frame}` : ''}`; p.append(a);
  return p.outerHTML;
}
export function videoFromClick(target: EventTarget | null): MediaSource | null {
  if (!(target instanceof Element)) return null;
  const video = target.closest<HTMLVideoElement>('video[data-video-review]');
  if (video) return { kind: 'video', url: video.src, name: video.dataset.filename || 'Видео', comments: readVideoComments(video.dataset.videoComments), attachmentId: Number(video.dataset.attachmentId) || undefined };
  const link = target.closest<HTMLAnchorElement>('a[data-video-review]');
  if (!link) return null;
  try { const url = new URL(link.href); if (!['http:', 'https:', 'blob:'].includes(url.protocol)) return null;
    const time = Number(link.dataset.videoTime || 0); url.hash = '';
    return { kind: 'video', url: url.href, name: link.dataset.videoName || 'Видео', time: Number.isFinite(time) ? Math.max(0, time) : 0, comments: readVideoComments(link.dataset.videoComments), attachmentId: Number(link.dataset.attachmentId) || undefined };
  } catch { return null; }
}
